import { CommonHelperFunctions } from "@kuika/kuika-cl-model";
import Axios from "axios";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

interface ICheckMcpAuthResponse {
  authUrlRedirectionRequired: boolean;
  redirectUrl: string;
}

export class McpClientService {
  public static CheckDropboxAuth(settingsId: string) {
    return Axios.get<ICheckMcpAuthResponse>(`${backendUrl}/McpClient/check_dropbox_auth`, { params: { settingsId } });
  }

  public static CheckOffice365Auth(settingsId: string) {
    return Axios.get<ICheckMcpAuthResponse>(`${backendUrl}/McpClient/check_office365_auth`, { params: { settingsId } });
  }

  public static CheckGoogleAuth(settingsId: string) {
    return Axios.get<ICheckMcpAuthResponse>(`${backendUrl}/McpClient/check_google_auth`, { params: { settingsId } });
  }
}
